import { useEffect, useState } from "react";

import { decoColumns } from "./misc/deco-columns";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useTemplates = () => {   
    const { platformId } = useParams();
    
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    const [data, setData] = useState({ templates: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();
    const [modalConfig, setModalConfig] = useState({ isOpen: false, row: {} });

    const handleModalConfig = (row = {}) => {
        setModalConfig(prev => ({ row, isOpen: !prev.isOpen }));
    };

    const getAllTemplates = async () => {
        const { data } = await axiosInstance.get(`/notes/${platformId}/template`, {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });
        setData({
            templates : data,
            pagination: data.pagination
        });
    };

    const handleRowActions = async (row = {}, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`/notes/${platformId}/template/${row._id}`);
            getAllTemplates();
            return;
        }
        handleModalConfig(row);
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getAllTemplates();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: decoColumns({ handleRowActions }),
        setQueryParams,
        handleModalConfig,
        modalConfig,
        getAllTemplates
    };
};

export default useTemplates;
